import { createSelector } from '@ngrx/store';

import { InterviewTemplateKind } from '@recruitee/http-types';
import {
  createEntityCollectionStore,
  memoizeSelector,
  getEntityCollectionActions,
} from '@recruitee/ngrx';

const idSelector = (entity: { name: string }) => entity.name;
const { actions, initialState, namespace, reducer, selectors } = createEntityCollectionStore<{
  name: string;
}>()('InterviewTemplatesCategories', {
  idSelector,
  customActions: adapter => {
    const reducerFunctions = getEntityCollectionActions(adapter, idSelector);

    return {
      fetchCollection: (state, payload: { scope: InterviewTemplateKind }) =>
        reducerFunctions.fetchCollection(state, payload),
    };
  },
});

const categoriesActions = <
  Pick<typeof actions, 'fetchCollection' | 'fetchCollectionSuccess' | 'fetchCollectionFailed'>
>actions;

const InterviewTemplateCategoriesSelectors = {
  ...selectors,
  entities: memoizeSelector((props: { scope: InterviewTemplateKind }) =>
    createSelector(selectors.entities(props), (state: Array<{ name: string }>) =>
      state.map(({ name }) => name),
    ),
  ),
};

export {
  actions,
  categoriesActions as InterviewTemplateCategoriesActions,
  namespace as InterviewTemplateCategoriesNamespace,
  initialState as InterviewTemplateCategoriesInitialState,
  reducer as InterviewTemplateCategoriesReducer,
  InterviewTemplateCategoriesSelectors,
};
